import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const ArchivoIntegracionExpedienteService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Archivo_Integracion_Expediente_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			archivo_integracion_expediente: form.archivo_integracion_expediente,
			is_required: form.is_required ? 1 : 0,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Archivo_Integracion_Expediente_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_archivo_integracion_expediente: form.id_cat_archivo_integracion_expediente,
			archivo_integracion_expediente: form.archivo_integracion_expediente,
			is_required: form.is_required ? 1 : 0,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Archivo_Integracion_Expediente_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_archivo_integracion_expediente) => {
		let params = {
			id_cat_archivo_integracion_expediente: id_cat_archivo_integracion_expediente
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Archivo_Integracion_Expediente_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
